import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { Loader2, Search, BarChart3 } from "lucide-react";
import api from "@/lib/api";
import { tInput } from "./trackUi";
import TrackAthleteProfile from "./TrackAthleteProfile";

export default function TrackPerformance({ orgId }) {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");
  const [sel, setSel] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try { const { data } = await api.get(`/track/athletes?organization_id=${orgId}`); setList(data); }
    catch { toast.error("Failed to load athletes."); } finally { setLoading(false); }
  }, [orgId]);
  useEffect(() => { load(); }, [load]);

  if (sel) return <TrackAthleteProfile athlete={sel} onBack={() => setSel(null)} />;

  const filtered = list.filter((a) => a.name.toLowerCase().includes(q.toLowerCase()));
  return (
    <div data-testid="track-performance">
      <h1 className="font-display font-black uppercase tracking-tighter text-4xl mb-6">Athlete Performance</h1>
      <div className="relative max-w-md mb-6">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/30" />
        <input data-testid="perf-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search athletes…" className={`${tInput} pl-10`} />
      </div>
      {loading ? <div className="flex justify-center py-16 text-white/40"><Loader2 className="animate-spin" /></div>
        : filtered.length === 0 ? <div className="border border-white/10 bg-[#121212] p-6 text-white/40 text-sm" data-testid="perf-empty">No athletes found.</div>
        : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="perf-list">
            {filtered.map((a) => (
              <button key={a.id} data-testid={`perf-athlete-${a.id}`} onClick={() => setSel(a)} className="text-left bg-[#121212] border border-white/10 p-4 hover:border-white/25 transition-colors flex items-center justify-between">
                <div><p className="font-bold">{a.name}</p><p className="text-white/40 text-xs mt-0.5">{a.gender === "F" ? "F" : "M"}{a.grad_year ? ` · '${String(a.grad_year).slice(-2)}` : ""}{(a.events || []).length ? ` · ${a.events.slice(0, 3).join(", ")}` : ""}</p></div>
                <BarChart3 size={16} className="text-white/30" />
              </button>
            ))}
          </div>
        )}
    </div>
  );
}
